


































































































































































































































































































































import style from "../my-theme/var.less";
import { Component, Vue, Watch } from "vue-property-decorator";
import { recentList, readMsg, logOff, queryMarkDuration, signClock } from "@/api/user/user";
import { isLogin, toLogin, formatDate, loading } from "../global/utils";
import { updateUserProfile, applyQc, deviceInfo} from "@/api/user/user";
import { DOMAIN } from "@/global/constants";
import SignIn from './signIn.vue';
import { uploadOss } from '@/global/utils'

@Component({
  components: {
    SignIn
  }
})
export default class Header extends Vue {
  private logoImgLight: string = process.env.VUE_APP_IMG_LOGO_LIGHT;
  private logoImgDark: string = process.env.VUE_APP_IMG_LOGO_DARK;
  private primary: string = style.primary;
  private modifyProfile: boolean = false;
  private realNameInput: boolean = false;
  private idCardInput: boolean = false;
  private modalTips: boolean = false;
  private userProfile = {};
  private other_job = "";
  private other_platform_str = "";
  private other_news_source = "";
  private sex = ["男", "女"];
  private education = ["小学", "初中", "高中", "大专", "本科", "研究生及以上"];
  private job = [
    "全职宝妈",
    "服务员",
    "售货员",
    "技工",
    "钟点工",
    "客服",
    "教师",
    "文员",
    "医护",
    "销售",
    "个体户",
    "自由职业",
    "其他",
  ];
  private work_time = ["6-8小时", "8-10小时", "10-12小时", "12小时及以上"];
  private work_time_slot = [
    "0:00-6:00",
    "6:00-12:00",
    "12:00-18:00",
    "18:00-24:00",
  ];
  private work_type = [
    "打点类",
    "拉框类",
    "OCR转写",
    "语义分割",
    "3D点云",
    "ASR音频转写",
    "TTS音素标注",
    "NLP文本标注",
    "视频标注",
    "无",
  ];
  private news_source = [
    "亲友推荐",
    "微信群、qq群",
    "朋友圈、公众号",
    "知乎、豆瓣社区",
    "应用商店看到",
    "网易、36氪等媒体",
    "头条、抖音、快手等平台",
    "百度、搜狗的搜索",
    "其他赚钱软件看到（请填写）",
  ];
  private target_job = ["全职", "兼职"];
  private target_money = [
    "1000元以下",
    "1000-3000元",
    "3000-5000元",
    "5000-7000元",
    "7000元",
  ];
  private path = "/index";
  private applyType = "";
  private shadow = true;
  private modualTaskType = Object.freeze({
    1: 51,
    2: 52,
    3: 53,
    4: 54,
    5: 55,
    6: 56,
    7: 57,
    9: 52,
    10: 55,
  });
  private rating: string[] = [
    '0-1000分',
    '1000-3000分',
    '3000-5000分',
    '5000-10000分',
    '10000-20000分',
    '20000分以上'
  ]
  percent: number = 101
  private columnItem: object[] = process.env.VUE_APP_HEAD_TABS
    ? JSON.parse(process.env.VUE_APP_HEAD_TABS)
    : [
        { name: "龙猫学院", icon: "iconfont icon-shouye", path: "index" },
        { name: "任务大厅", icon: "iconfont icon-renwu", path: "task" },
        { name: "荣誉榜", icon: "iconfont icon-jiangbei", path: "top" },
        {
          name: "个人中心",
          icon: "iconfont icon-gerenzhongxin",
          path: "message",
        },
      ];

  private userItem: object[] = [
    // {
    //   name: '个人中心',
    //   icon: 'ios-person',
    //   path: 'mine',
    // },

    {
      name: "帮助文档",
      icon: "md-help",
      path:
        process.env.VUE_APP_URL_HELP ||
        "https://www.kancloud.cn/longmao/longmao/1150122",
    },
    {
      name: "反馈建议",
      icon: "ios-clipboard",
      path:
        process.env.VUE_APP_URL_PROPOSAL ||
        "http://ar3w88l0b6u79cu.mikecrm.com/mzEyo86",
    },
    {
      name: "退出登录",
      icon: "ios-log-out",
      path: "index",
    },
  ];

  private signVisible: boolean = false
  private signData: object = {}

  get userInfo() {
    return this.$store.state.userInfo;
  }
  get isOffline() {
    return (this.$root as any).offline;
  }
  get teamInfo() {
    return this.$store.state.team;
  }

  get currentTag() {
    if (this.$route.path.startsWith("/task")) {
      return "task";
    } else if (this.$route.path.startsWith("/index")) {
      return "index";
    } else if (this.$route.path.startsWith("/mine")) {
      return "message";
    } else if (this.$route.path.startsWith("/top")) {
      return "top";
    } else if(this.$route.path.startsWith("/train")) {
      return 'train'
    }
  }

  get unReadMsg() {
    const msgList: object = this.$store.state.unReadMsg;
    if (msgList && Array.isArray((msgList as any).rows)) {
      (msgList as any).rows.forEach((item) => {
        try {
          const msg = JSON.parse(item.message);
          item.message = msg;
          item.isJump = true;
        } catch (err) {
          console.warn(err);
          const msg = item.message;
          item.message = {
            time: formatDate(item.time),
            title: msg,
            mid: item.id,
          };
          item.isJump = false;
        }
      });
    }
    return msgList;
  }

  get isShowMessage() {
    if (this.isOffline && process.env.VUE_APP_PAGE_HIDE) {
      const removeRouteList = JSON.parse(process.env.VUE_APP_PAGE_HIDE);
      return !(
        Array.isArray(removeRouteList) && removeRouteList.includes("消息中心")
      );
    }
    return true;
  }

  @Watch("$route")
  private routeChange(to: any, from: any) {
    this.path = to.path;
  }

  private openUrl() {
    this.modalTips = false;
    window.open(
      "https://ueds4rpous.feishu.cn/docs/doccn3UEJjaRhqnj4dq9yWguZsh#",
      "_blank"
    );
  }

  private async selectTags(path: string, ...args) {
    if (path) {
      if (path.indexOf("http") > -1) {
        // 帮助、反馈
        window.open(path);
      } else {
        if (path === "index") {
          // 退出
          this.$store.dispatch("logoutUser");
          // 个人中心下登出 则跳转首页
          if (this.$route.fullPath.indexOf("mine") > -1) {
            this.$router.push({ path: "/" });
          }
        } else if (path === "mine" || path === "message") {
          // 个人中心
          this.$router.push({ name: path });
        } else {
          // 消息
          const args = path.split("_");
          const id = args[1];
          const mid = args[2];
          const type = args[3];
          const isJump = args[4] === "0";
          const lid = args[5];
          const from = args[6];
          const markType = args[7];

          // 标记为已读
          const res = await readMsg({ id: id });
          if (isJump) return;
          // 重新获取消息
          this.$store.dispatch("getRecentList");
          if (type == "2400") {
            window.open(
              "http://help.longmaosoft.com/forum.php?mod=viewthread&tid=862&page=1&extra=#pid3001",
              "_blank"
            );
          } else if (lid) {
            // 重做
            this.openEditor({ mid, lid, from, markType });
          }
          {
            // 跳转任务详情页
            this.$router.push({ path: `/task/pkgTask/detail/${mid}` });
          }
        }
      }
    }
  }

  // 重做做题 跳转页面
  private openEditor(data) {
    if (!isLogin(this)) {
      return;
    }
    let url = `${DOMAIN}/tools/`;
    if (/^sketch(-.+)?$/.test(data.from)) {
      const parts = data.from.split("-");
      url += `${parts.length > 1 ? parts[1] : "markPage"}.html`;
    } else if (data.from) {
      url += data.from + ".html";
    } else {
      url += "markPage.html";
    }
    url += `?type=${this.modualTaskType[data.markType]}&id=${data.mid}&lid=${
      data.lid
    }&version=2&stage=2`;
    window.open(url);
  }

  // 选择上方菜单
  private selectColumn(path: string) {
    if (path.indexOf("http") > -1) {
      // 如果当前用户没有申请团队 则进入团队申请页面
      if (path.indexOf("team") > -1) {
        if (!isLogin(this)) {
          return;
        }
        const userInfo: any = this.userInfo;
        if (userInfo && userInfo.id && !userInfo.offline_user) {
          this.$router.push({ name: "team_guide" });
        } else {
          let dev = /^dev.+$/.test(window.document.domain) ? "dev." : "";
          if (dev === "") {
            window.open(path);
          } else {
            window.open("http://dev.team.longmaosoft.com");
          }
        }
      } else {
        window.open(path);
      }
    } else {
      if (
        (path.indexOf("mine") > -1 || path.indexOf("message") > -1) &&
        !isLogin(this)
      ) {
        return;
      }
      this.$router.push({ name: path });
    }
  }

  private handleLogin() {
    toLogin();
  }

  private handleTager(type) {
    const userInfo: any = this.userInfo;
    if (userInfo && userInfo.id) {
      if (userInfo.outTeam7Day) {
        this.$Message.info("退出公会不足七天，无法重新申请");
      } else {
        this.applyType = type;
        if (type === "qc") {
          // 质检员
          if (this.userInfo.apply_qc === true) {
            if (this.userInfo.real_name) {
              this.userProfile["real_name"] = this.userInfo.real_name;
              this.realNameInput = true;
            }
            if (this.userInfo.id_card) {
              this.userProfile["id_card"] = this.userInfo.id_card;
              this.idCardInput = true;
            }
            this.modifyProfile = true;
          } else {
            this.$Modal.info({
              title: "提示",
              content:
                "获得培训任务【新兵营】和【工具培训】所有勋章才可申请成为质检员哦！",
            });
          }
        } else {
          // 标注员
          this.modifyProfile = true;
          if (this.userInfo.real_name) {
            this.userProfile["real_name"] = this.userInfo.real_name;
            this.realNameInput = true;
          }
          if (this.userInfo.id_card) {
            this.userProfile["id_card"] = this.userInfo.id_card;
            this.idCardInput = true;
          }
        }
      }
    } else {
      this.$Message.info("请先点击页面右上方注册龙猫账号。");
    }
  }

  private async handleToUpdateProfile() {
    var data = { ...this.userProfile } as any;

    if (data.work_time_slot) {
      data.work_time_slot = JSON.stringify(data.work_time_slot);
    }
    if (data.work_type) {
      data.work_type = JSON.stringify(data.work_type);
    }

    var real_name = data.real_name;
    var wx_code = data.wx_code;
    var mobile = data.mobile;

    var sex = data.sex;
    var old_years = data.old_years;
    var education = data.education;
    var job = data.job;
    var born_city = data.born_city;
    var now_city = data.now_city;
    var nation = data.nation;
    var target_job = data.target_job;
    var target_money = data.target_money;

    var work_time = data.work_time;
    var work_time_slot = data.work_time_slot;
    var work_type = data.work_type;
    var news_source = data.news_source;

    var error = false;
    if (!real_name || real_name == "") {
      this.$Message.error("请输入真实姓名");
      error = true;
      return;
    }
    if (!wx_code || wx_code == "") {
      this.$Message.error("请输入微信号");
      error = true;
      return;
    }
    if (!mobile || mobile == "") {
      this.$Message.error("请输入手机号");
      error = true;
      return;
    }

    if (!sex || sex == "") {
      this.$Message.error("请选择性别");
      error = true;
      return;
    }

    if (!old_years || old_years == "") {
      this.$Message.error("请输入年龄");
      error = true;
      return;
    }

    if (!education || education == "") {
      this.$Message.error("请选择学历");
      error = true;
      return;
    }
    if (!target_job || target_job == "") {
      this.$Message.error("请选择希望找什么类型工作");
      error = true;
      return;
    }
    if (!target_money || target_money == "") {
      this.$Message.error("请选择希望在平台赚多少钱");
      error = true;
      return;
    }

    if (!job || job == "") {
      this.$Message.error("请选择职位");
      error = true;
      return;
    }

    if (!born_city || born_city == "") {
      this.$Message.error("请输入出生城市");
      error = true;
      return;
    }

    if (!now_city || now_city == "") {
      this.$Message.error("请输入居住城市");
      error = true;
      return;
    }

    if (!nation || nation == "") {
      this.$Message.error("请输入民族");
      error = true;
      return;
    }

    if (!work_time || work_time == "") {
      this.$Message.error("请选择每天工作时长");
      error = true;
      return;
    }

    if (!work_time_slot || work_time_slot == "") {
      this.$Message.error("请选择每天工作的时段");
      error = true;
      return;
    }

    if (!work_type || work_type == "") {
      this.$Message.error("请选择曾经做过的标注类型");
      error = true;
      return;
    }

    if (job && job.toString().endsWith("其他")) {
      if (!this.other_job || this.other_job == "") {
        this.$Message.error("请输入其他职业");
        error = true;
        return;
      }
      data.job = data.job + this.other_job;
    }

    if (this.applyType !== "qc") {
      if (!news_source || news_source == "") {
        this.$Message.error("请选择在哪里了解到龙猫数据标注平台");
        error = true;
        return;
      }
      if (
        news_source &&
        news_source.toString().endsWith("其他赚钱软件看到（请填写）")
      ) {
        if (!this.other_news_source || this.other_news_source == "") {
          this.$Message.error("请输入在哪个软件看到");
          error = true;
          return;
        }
        data.news_source = "其他" + this.other_news_source;
      }
    }

    if (error) {
      return;
    }
    data.input_tagger = 1;
    if (this.applyType === "qc") {
      data.input_apply_qc = 1;
      const res = (await applyQc(data)) as any;
      if (res.code == "200") {
        this.modifyProfile = false;
        this.$store.state.userInfo.isShowTagger = false;
        this.$Message.success("提交成功");
      } else {
        this.$Message.error(res.message);
      }
    } else {
      const res = (await updateUserProfile(data)) as any;
      if (res.code == "200") {
        this.modifyProfile = false;
        this.$store.state.userInfo.isShowTagger = false;
        this.$Message.success("提交成功");
        this.modalTips = true;
      } else {
        this.$Message.error(res.message);
      }
    }
  }

  private async created() {
    await this.$store.dispatch("initUserInfo");
    this.path = this.$route.path;

    if (this.path.startsWith("/trainDetail")) {
      this.shadow = false;
    } else {
      this.shadow = true;
    }
    //device_memory
    //hardware_concurrency
    //platform
    //app_version
    //user_agent_platform
    //time
    if (this.userInfo && this.userInfo.id) {
      let navigator = window.navigator;
      if (navigator) {
        let data = {};
        if (navigator["deviceMemory"]) {
          data["device_memory"] = navigator["deviceMemory"];
        }
        if (navigator.hardwareConcurrency) {
          if (
            navigator.appVersion &&
            (navigator.appVersion.indexOf("mac") != -1 ||
              navigator.appVersion.indexOf("Mac") != -1 ||
              navigator.appVersion.indexOf("MAC") != -1)
          ) {
            if (navigator.hardwareConcurrency) {
              data["hardware_concurrency"] = Math.ceil(
                Number(navigator.hardwareConcurrency / 2)
              );
            }
          } else {
            data["hardware_concurrency"] = navigator.hardwareConcurrency;
          }
        }

        if (navigator.platform) {
          data["platform"] = navigator.platform;
        }
        if (navigator.appVersion) {
          data["app_version"] = navigator.appVersion;
        }
        if (navigator["userAgentData"] && navigator["userAgentData"].platform) {
          data["user_agent_platform"] = navigator["userAgentData"].platform;
        }
        let gpu = this.getGPU();
        if (gpu) {
          data["gpu"] = gpu;
        }
        const res = (await deviceInfo(data)) as any;
      }
    }
  }

  getGPU() {
    const canvas = document.createElement("canvas"),
      gl = canvas.getContext("webgl2"),
      debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
    const info = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
    return info;
  }

  upload(e) {
    let file = e.target.files[0];
    if(!file) return;
    this.percent = 0;
    let times = new Date().getTime();
    let extension = file.name.split('.')[1];
    let key = `${this.userInfo.id}/${times}.${extension}`;
    uploadOss(file, key).then(res => {
      const timer = setInterval(() => {
        this.percent += 10;
        if(this.percent >= 100) {
          clearInterval(timer);
          (this.userProfile as any).rating_img = res;
        }
      }, 50)
    }).catch(err => {
      console.log(err)
      alert('上传失败');
    })
  }

  get isShowSignBtn() {
    const type = this.userInfo.clock_type
    return type === 0 || type === 1
  }


  async handleSign() {
    const self = this

    // 未打卡,打上班卡
    if(this.userInfo.clock_type === 0) {
      sign()
    } 
    // 已打上班卡，打下班卡
    else if(this.userInfo.clock_type === 1) {
      loading.show(this, '打卡中...')
      const res:any = await queryMarkDuration().finally(() => loading.hide(this))
      if(res && res.code === '200') {
        const dotime = res.result.do_time
        if(dotime < 8 * 60 * 60) {
          const time = (this as any).$moment.utc(dotime * 1000).format('HH小时mm分ss秒')
          this.$Modal.confirm({
            title: '温馨提示',
            render: (h) => {
              return h('div', {
                style: 'font-size: 14px;color: #666666;line-height: 22px;text-align:center;height: 120px;padding-top: 30px'
              }, 
              [
                h('div', `今日工作时长：${time} `),
                h('div', '工时不达标，要不要再努力做几题？')
              ])
            },
            okText: '继续做题',
            cancelText: '确认打卡',
            onOk: () => {
              this.$Modal.remove()
            },
            onCancel: () => {
              console.log('打卡')
              sign()
              this.$Modal.remove()
            }
          })
        } else {
          sign()
        }
      } else {
        this.$Message.error(res.message || '打卡失败')
      }
    }


    async function sign() {
      loading.show(self, '打卡中...')
      const res:any = await signClock().finally(() => loading.hide(self))
      if(res && res.code === '200') {
        self.signData = res.result
        self.signVisible = true
        if(self.userInfo.clock_type === 0) {
          self.$store.commit('setClockType', 1)
        } else if(self.userInfo.clock_type === 1) {
          self.$store.commit('setClockType', 2)
        }
      } else {
        self.$Message.error(res.message || '打卡失败')
      }
    }
  }


  
  // getGPU() {
  //   const canvas = document.createElement('canvas')
  //   const gl = canvas.getContext("webgl2");
  //   var debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
  //   if (!debugInfo) {
  //     return null;
  //   }
  //   var vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
  //   var renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
  //   return {
  //     vendor: vendor,
  //     renderer: renderer,
  //   };
  // }
}
